import { Box, Stack, Typography } from '@mui/material';
import Image, { type StaticImageData } from 'next/image';

import { ButtonWithIcon } from '@/components/buttons/buttonWithIcon';
import { Icon } from '@/components/shared/icon';

import pinkBackgroundSpaceship from '../../../public/statics/images/illustrations/onboarding/pink_background_spaceship.png';

export const WelcomePageWrapper = ({
  children,
  illustration,
  onBack,
  contentAlignment = 'center',
}: React.PropsWithChildren<{
  illustration?: { src: StaticImageData; alt: string };
  onBack?: () => void;
  // Content that grows as the visitor fills it in starts at the top, so what is already there doesn't move.
  contentAlignment?: 'center' | 'top';
}>) => {
  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        padding: 'var(--mui-layout-wideSpacing)',
      }}
    >
      <Stack
        direction='row'
        sx={{
          width: '100%',
          height: '100%',
          justifyContent: 'space-between',
        }}
      >
        <Box className='flex items-center'>
          {illustration ? (
            <Image
              alt={illustration.alt}
              src={illustration.src}
              style={{ width: '40vw', height: 'auto' }}
              priority
            />
          ) : (
            <Image
              alt='bring-your-own-cloud'
              height={760}
              width={760}
              src={pinkBackgroundSpaceship}
              style={{ width: '40vw', height: '40vw' }}
              priority
            />
          )}
        </Box>
        <Stack
          className='bg-[white] rounded-[var(--mui-shape-customBorderRadius-lg)] overflow-y-auto'
          sx={{
            padding: 'var(--mui-layout-wideSpacing)',
            minWidth: '50%',
            gap: '40px',
          }}
        >
          {onBack && (
            <ButtonWithIcon
              onClick={onBack}
              text='Back'
              icon='material-symbols-chevron-left-rounded'
              iconPosition='left'
            />
          )}
          <Stack
            sx={{
              flexGrow: 1,
              justifyContent:
                contentAlignment === 'top' ? 'flex-start' : 'center',
            }}
          >
            {children}
          </Stack>
        </Stack>
      </Stack>
    </Box>
  );
};

export const WelcomePageListItem = ({ text }: { text: string }) => {
  return (
    <Stack
      direction='row'
      sx={{
        gap: '12px',
        alignItems: 'center',
      }}
    >
      <Icon iconClass='material-symbols-check' />
      <Typography variant='subtitle1'>{text}</Typography>
    </Stack>
  );
};
